.citation_class {
    font-size: 12px;
    color: #31568e;
    font-weight: 700;
    font-style: normal;
}

.scrollFadeContent {
    &::before {
        border-radius: 10px;
        content: '';
        display: inline-block;
        position: absolute;
        width: 100%;
        height: 50px;
        background-image: linear-gradient(white 20%, transparent 100%);
        top: 0;
        z-index: 5000;
    }
}
